module.exports = __webpack_public_path__ + "img/zzrc-qr-code.a22175a5.jpg";